import { useCallback, useEffect, useState } from "react"
import { useComrpobantDetailPaymentServices } from "../../../hooks/useComrpobantDetailPaymentServices"
import useCurrentLocation from "@thooks/useCurrentLocation"

export const useComprobantDetailPaymentBody = () => {

    const { param } = useCurrentLocation()
    const [comprobantDetailData, setComprobantDetailData] = useState({})
    const [detailPaymentData, setDetailPaymentData] = useState({})
    const [loadingReceivedPaymentDetail, setLoadingReceivedPaymentDetail] = useState(false)

    const { getChargeInstanceDebtorPaymentDetailService, getChargeInstanceDebtorDetailService } = useComrpobantDetailPaymentServices()

    const getInitialData = useCallback(async () => {
        const res = await getChargeInstanceDebtorPaymentDetailService({
            setLoading: setLoadingReceivedPaymentDetail,
            charge_instance_id: param.chargeInstanceId,
            place_id: param.placeId
        })
        const detailRes = await getChargeInstanceDebtorDetailService({
            setLoading: setLoadingReceivedPaymentDetail,
            charge_instance_id: param.chargeInstanceId,
            place_id: param.placeId
        })
        setDetailPaymentData(detailRes)
        setComprobantDetailData(res)
    }, [
        getChargeInstanceDebtorPaymentDetailService,
        getChargeInstanceDebtorDetailService,
        param.chargeInstanceId,
        param.placeId
    ])

    useEffect(() => {
        getInitialData()
    }, [getInitialData])

    return {
        loadingReceivedPaymentDetail,
        detailPaymentData,
        comprobantDetailData
    }
}